export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7709.3ff7386d.jpg";